import { ValidationRuleTriggers } from "./triggers";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { localize } from "client_legacy/ndaw/culture";

export class IsAfterRule extends ValidationRuleTriggers<Date | null> {
	private readonly _alternativeMessage: string | undefined;
	private readonly _minimalDateTimestamp: number;

	constructor(minimalDateTime: Date, alternativeMessage?: string) {
		super();
		this._alternativeMessage = alternativeMessage;
		this._minimalDateTimestamp = minimalDateTime.getTime();
	}

	public validate(value: Date | null): InputValidationResult {
		if (!value || value.getTime() >= this._minimalDateTimestamp) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: this._alternativeMessage || localize("_DateMustBeAfter")
		};
	}
}

export class IsValidDate extends ValidationRuleTriggers<Date | null> {

	public validate(value: Date | null): InputValidationResult {
		if (
			!value
			|| (
				!isNaN(value.getTime())
				&& value <= MAX_DATE
				&& value >= MIN_DATE
			)
		) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: localize("_DateIsInvalid")
		};
	}
}

/**
 * Min and max are from .NET DateTimeOffset.MinValue/MaxValue
 */
const MAX_DATE: Date = new Date(Date.UTC(9999, 11, 31, 23, 59, 59));
const MIN_DATE: Date = new Date(Date.UTC(1, 0, 1, 0, 0, 0));
MIN_DATE.setFullYear(1);